import Api from './api.service'

const baseURL = process.env.VUE_APP_API_PAGE

export default {
  getList () {
    return Api().get(baseURL + '/backend/widget')
  },
  store (payload) {
    return Api().post(baseURL + '/backend/widget', payload)
  }
}
